import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormErrorService } from '../../../services/form-error.service';

@Component({
  selector: 'app-input-field-error',
  templateUrl: './input-field-error.component.html',
  styleUrls: ['./input-field-error.component.scss'],
  standalone: true,
  imports: [],
})
export class InputFieldErrorComponent implements OnInit {
  @Input() control: AbstractControl;
  @Input() rounded = false;
  showError = false;
  error: string;

  constructor(public formErrors: FormErrorService) {}

  ngOnInit() {
    this.showError = true;
  }

  getError() {
    if (!this.control.valid) this.error = this.formErrors.getFieldError(this.control);
    return this.error;
  }
}
